import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    // Not logged in — redirect to login
    return <Navigate to="/login" replace />;
  }

  // Token exists — allow access
  return children;
};

export default PrivateRoute;
